export const nhomHang = {
  sections: {
    list: { title: 'Nhóm hàng' },
    tree: { title: 'Nhóm hàng — Dạng cây' },
    viewBasic: 'Thông tin cơ bản',
    viewLinkage: 'Nhóm cha',
    viewStatus: 'Trạng thái',
    viewAudit: 'Lịch sử',
  },
  hints: {
    organize:
      'Tổ chức nhóm hàng theo cấp bậc để lọc và chọn hàng loạt hàng hóa tiện lợi hơn.',
    description: 'Quản lý hàng hóa theo chủng loại, đặc tính, công năng.',
  },
  fields: {
    code: 'Mã nhóm',
    name: 'Tên nhóm',
    description: 'Mô tả',
    parentGroup: 'Nhóm cha',
    level: 'Cấp',
    productCount: 'SL hàng hóa',
    status: 'Trạng thái',
    onOffAction: 'Bật tắt',
    listOrder: 'Thứ tự',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  status: {
    active: 'Hoạt động',
    inactive: 'Không hoạt động',
    all: 'Tất cả',
  },
  filters: {
    all: 'Tất cả',
    groupTreeSection: 'Nhóm hàng',
    treeAll: 'Tất cả nhóm',
    treeSearch: 'Tìm kiếm nhóm hàng',
    statusSection: 'Trạng thái',
    relatedSection: 'Liên kết',
    relatedHint: 'Mở danh sách hàng hóa để gán nhóm cho sản phẩm.',
    openProducts: 'Danh sách hàng hóa',
    maNhomCha: 'Mã nhóm cha',
    sortSection: 'Sắp xếp',
  },
  trangThai: {
    DANG_HOAT_DONG: 'Đang hoạt động',
    NGUNG_HOAT_DONG: 'Ngừng hoạt động',
  },
  placeholders: {
    searchParentNhomHang: 'Chọn nhóm cha',
    searchCodeName: 'Theo mã, tên nhóm',
    maAuto: 'Tự sinh: NHTBPC001, cấp 2 NHTBPC001-01, cấp 3 NHTBPC001-01-01',
    tenNhom: 'Nhập tên nhóm hàng',
  },
  messages: {
    noData: 'Không có dữ liệu',
    listSummary: 'Tổng số bản ghi: {count}',
    listSummaryKiot: 'Tổng số {count} nhóm theo bộ lọc',
    saving: 'Đang lưu…',
    createSuccess: 'Tạo nhóm hàng thành công',
    updateSuccess: 'Cập nhật nhóm hàng thành công',
    deleteSuccess: 'Đã xóa nhóm hàng',
    deleteError: 'Không thể xóa nhóm hàng',
    deleteSelected: 'Xóa đã chọn ({count})',
    selectedCount: 'Đã chọn: {count}',
    bulkDeleteConfirm: 'Xóa {count} nhóm hàng đã chọn? (Xóa từng nhóm qua API; nhóm có con cần xóa con trước.)',
    bulkDeleteSuccess: 'Đã xóa {count} nhóm hàng',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} nhóm không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn nhóm nào để xóa',
    loadError: 'Không tải được dữ liệu',
    confirmDelete: 'Bạn có chắc muốn xóa nhóm «{name}»?',
    searchPlaceholder: 'Lọc theo mã hoặc tên…',
    reorderError: 'Không cập nhật được thứ tự',
    exportComingSoon: 'Chức năng Xuất file nhóm hàng sẽ sớm được cập nhật',
  },
  import: {
    description: 'Chọn file Excel theo mẫu tải về (Mã nhóm, Tên nhóm, Trạng thái, Mã nhóm cha).',
    success: 'Import nhóm hàng thành công',
    failed: 'Import nhóm hàng thất bại',
    noData: 'Không có dòng dữ liệu hợp lệ trong file',
    noSheet: 'File Excel không có sheet dữ liệu',
  },
  actions: {
    addChild: 'Thêm cấp dưới',
    moveUp: 'Lên trên',
    moveDown: 'Xuống dưới',
    toggleStatus: 'Đổi trạng thái',
    createInline: 'Tạo mới',
  },
  tabs: {
    info: 'Thông tin',
    products: 'Hàng hóa',
  },
  products: {
    hint: 'Hàng hóa',
    export: 'Xuất file',
    create: 'Tạo hàng hóa',
    empty: 'Nhóm này chưa có hàng hóa',
    loadError: 'Không tải được danh sách hàng hóa',
    code: 'Mã hàng',
    name: 'Tên hàng',
    unit: 'ĐVT',
    price: 'Giá bán',
    stock: 'Tồn kho',
  },
  titles: {
    addNew: 'Thêm nhóm hàng',
    addQuick: 'Thêm nhanh',
    edit: 'Sửa nhóm hàng',
    detail: 'Chi tiết nhóm hàng',
  },
  viewModes: {
    list: 'Danh sách',
    tree: 'Dạng cây',
    level: 'Dạng bảng',
  },
  levelTable: {
    lv1: 'Mã LV1',
    lv2: 'Mã LV2',
    lv3: 'Mã LV3',
    lv4: 'Mã LV4',
  },
}
